/***
 * Created on 2023/10/25
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import TextInput from "../common/form/text_input";
import {useTranslation} from "react-i18next";
import {checkQIDFormat} from "common/ServiceUser";
import {getErrorMessage} from 'common/ServiceCommon';
import {useOnChange, useLanguage} from "common/Hook";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiPost, executeGrecaptcha} from "../../service/api";
import Captcha from "../common/captcha";
import {useNavigate} from "react-router-dom";


function ForgetPasswordIndex({qid, setQid}) {
    const { t, i18n } = useTranslation();
    useLanguage(i18n);
    const queryClient = useQueryClient()
    const {values, onChange, setValues} = useOnChange({qid: ''});
    const [validQid, setValidQid] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    const validateQidOnChange = (e) => {
        if (e.target.value) {
            setValidQid( ['email', 'phone'].includes(checkQIDFormat(e.target.value)) )
        }
        // setQid(e.target.value);
        onChange(e);
    }

    const forgetMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/forget_password', data),
        onSuccess: data => {
            const qid_type = checkQIDFormat(values.qid);
            // setQid(values.qid);
            if (qid_type === 'phone') {
                // window.location.href = '/forget_password#phone_verify';
                navigate("/forget_password/phone_verify", {state: {...data}});
                // window.location.reload();
            }
            else {
                navigate(`/forget_password/success${location.search?.length > 0 ? location.search : ''}`, {state: {qid: values.qid}});
            }
        },
        onError: (error, variables, context) => {
            if (error?.cause?.code !== 1019014)  {
                setErrorMessage(getErrorMessage(t, error.cause?.code));
            }
            queryClient.invalidateQueries({
                key: ['get_captcha_image'],
            })
        }
    });

    const onContinue = async () => {
        setErrorMessage(null);
        await executeGrecaptcha("FORGET_PASSWORD", async (recaptcha_token) => {
            await forgetMutation.mutateAsync({qid: values.qid, recaptcha_token, captcha: values?.captcha});
        });
    }

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@Forgot Password@')}</div>
            <div className="common-page-body">
                <p>{t('@Enter QNAP ID:@')}</p>
                <div className="common-form-group">
                    <div className="comp-input">
                        <div className="input-field--modern">
                            <TextInput
                                name='qid'
                                value={values.qid}
                                inputMode={"email"}
                                onChange={validateQidOnChange}
                                label={t('@Email or Phone@')}
                                placeholder={t('@Email or Phone@')}
                                required={true}/>
                        </div>
                    </div>
                    {errorMessage && <p className="text-error mt-10">{errorMessage}</p>}
                </div>

                <Captcha value={values.captcha} inputChangeHandler={onChange} resetValue={() => setValues(prev => ({...prev, captcha: ''}))}/>

            </div>
            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-normal" disabled={!validQid} onClick={onContinue}>{t('@Continue@')}</button>
                </div>
            </div>
        </section>
    );
}

export default ForgetPasswordIndex;